import { useMemo } from "react";

export function usePagination<T>(array: T[], perPage: number, page: number) {
  const numberOfPages = useMemo(() => Math.ceil(array.length / perPage), [array, perPage]);

  const pageItems = useMemo(() => {
    return array.slice((page - 1) * perPage, page * perPage);
  }, [array, page, perPage]);

  return { numberOfPages, pageItems, length: array.length };
}
